import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Button from 'src/components/Button';
import Loader from 'src/components/Loader';
import SelectBox from 'src/components/SelectBox/SelectBox';
import Styled from 'src/components/MobilePhotoQuestionManagePopup/MobilePhotoQuestionManagePopup.styles';

const MobilePhotoQuestionManagePopup = (props) => {
  const {
    allPhotoRecords,
    jobChecklistsQuestions,
    jobId,
    linkingOrRemovingQuestions,
    onCloseHandler,
    readOnly,
    saveAndApplyHandler,
    selectedRecord
  } = props;
  const { t } = useTranslation();
  const [allQuestions, setAllQuestions] = useState([]);
  const [existingQuestions, setExistingQuestions] = useState([]);
  const [remainingQuestions, setRemainingQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [questionsToBeRemoved, setQuestionsToBeRemoved] = useState([]);

  useEffect(() => {
    setAllQuestions(jobChecklistsQuestions);
  }, []);

  useEffect(() => {
    const questionsOfSelectedImage = allPhotoRecords.filter(photoRecord => {
      return photoRecord.checklistId &&
        photoRecord.questionId &&
        photoRecord.filename === selectedRecord.filename;
    });

    setExistingQuestions(allQuestions.filter(question => {
      return !!questionsOfSelectedImage.find(record => {
        return record.questionId === question.questionId &&
          record.checklistId === question.checklistId;
      });
    }));
  }, [allQuestions]);

  useEffect(() => {
    setRemainingQuestions(allQuestions.filter(question => {
      return ![...existingQuestions, ...selectedQuestions].find(existingQuestion => {
        return existingQuestion.uniqueId === question.uniqueId;
      });
    }));
  }, [existingQuestions, selectedQuestions]);

  const onselect = async ({ value }) => {
    const selectedQuestion = allQuestions.find(question => question.uniqueId === value);
    if (!selectedQuestion) {
      return;
    }
    setSelectedQuestions([selectedQuestion, ...selectedQuestions]);
  };

  const inQuestionsToBeRemoved = (question = {}) => questionsToBeRemoved.find(q => q.uniqueId === question.uniqueId);

  const removeQuestion = (question) => {
    if (!question) {
      return;
    }

    if (!inQuestionsToBeRemoved(question)) {
      setQuestionsToBeRemoved([...questionsToBeRemoved, question]);
    }
  };

  const undoRemoveQuestion = (question) => {
    if (!question) {
      return;
    }

    if (inQuestionsToBeRemoved(question)) {
      setQuestionsToBeRemoved([...questionsToBeRemoved.filter(q => q.uniqueId !== question.uniqueId)]);
    }
  };

  return (
    <Styled.Container>
      <Styled.PopupComponent isCloseHidden={true} onClose={onCloseHandler}>
        <Styled.PopupInner>
          <h3>{t('EXISTING_LINKS')}</h3>
          <Styled.ExistingQuestionsSection>
            {([...selectedQuestions, ...existingQuestions]).map(question => {
              const markedForRemoval = !!inQuestionsToBeRemoved(question);
              return (
                <Styled.ExistingQuestionWrapper key={question.uniqueId}>
                  <Styled.ExistingQuestionNumber
                    className={markedForRemoval ? Styled.Classes['remove-question-text'] : ''}>{question.questionNumber}</Styled.ExistingQuestionNumber>
                  <Styled.ExistingQuestionText
                    className={markedForRemoval ? Styled.Classes['remove-question-text'] : ''}>{question.text}</Styled.ExistingQuestionText>
                  {!readOnly && (markedForRemoval ?
                    <Styled.ExistingQuestionRemoveIcon name="reload" onClick={() => undoRemoveQuestion(question)} /> :
                    <Styled.ExistingQuestionRemoveIcon name="cross" onClick={() => removeQuestion(question)} />
                  )}
                </Styled.ExistingQuestionWrapper>);
            })
            }
          </Styled.ExistingQuestionsSection>
          {!readOnly && <SelectBox
            closeMenuOnSelect={false}
            label={t('ADD_LINK_TO_QUESTION')}
            maxMenuHeight={'18rem'}
            onChange={onselect}
            options={remainingQuestions.map(question => ({
              value: question.uniqueId, label: `${question.questionNumber} ${question.text}`
            }))}
            value={null}
          />}

          <Styled.PopupFooter>

            <Styled.PopupFooterActionBar>
              {!readOnly && (
                linkingOrRemovingQuestions ? <Loader withText={false} /> :
                  <Button
                    className={Styled.Classes['btn-save-and-apply']}
                    disabled={[...selectedQuestions, ...questionsToBeRemoved].length === 0}
                    onClick={() => saveAndApplyHandler(selectedQuestions, questionsToBeRemoved)}
                    type="button">
                    Save And Apply
                  </Button>
              ) }

              <Styled.LinkButton
                ghost
                onClick={(e) => {
                  e.target.blur();
                  onCloseHandler();
                }}
                red
                sm
                type="button"
              >
                {readOnly ? t('CLOSE'): t('CANCEL')}
              </Styled.LinkButton>
            </Styled.PopupFooterActionBar>
          </Styled.PopupFooter>
        </Styled.PopupInner>
      </Styled.PopupComponent>
    </Styled.Container>);
};

MobilePhotoQuestionManagePopup.propTypes = {
  allPhotoRecords: PropTypes.array.isRequired,
  jobId: PropTypes.number.isRequired,
  jobChecklistsQuestions: PropTypes.array,
  linkingOrRemovingQuestions: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  readOnly: PropTypes.bool,
  saveAndApplyHandler: PropTypes.func,
  selectedRecord: PropTypes.object,
};

MobilePhotoQuestionManagePopup.defaultProps = {
  jobChecklistsQuestions: [],
  linkingOrRemovingQuestions: false,
  onCloseHandler: () => {
  },
  readOnly: true,
  saveAndApplyHandler: () => {
  },
  selectedRecord: {}
};

export default MobilePhotoQuestionManagePopup;
